<template>
  <v-card class="rounded-t-0">
    <v-tabs v-model="tab" centered background-color="#638290" dark>
      <v-tabs-slider color="#FFBE71"></v-tabs-slider>
      <v-tab to='/oficios/Entrantes?page=1&search=&filter=0&words=false'>ENTRANTES</v-tab>
      <v-tab to='/oficios/Generados?page=1&search=&filter=0&words=false' >GENERADOS</v-tab>
      <v-tab v-if ="role!='user'" to='/oficios/DePara?page=1&search=&filter=0' >DE/PARA</v-tab>
    </v-tabs>
    <router-view></router-view>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed:{
        ...mapGetters(["role"])
    },
  data: () => ({
    tab: 0,
  }),
    
};
</script>
